<template>
  <div id="editAvatarWindow" style="display: grid; justify-content: center">
    <div v-if="!loadCamera">
      <!-- avatar preview -->
      <div class="text-center">
        <v-badge
          v-if="avatarImage != ''"
          bordered
          color="grey lighten-2"
          overlap
          offset-x="-60"
          offset-y="-25"
          @click.native="delAvatar()"
          style="z-index: 1; cursor: pointer"
        >
          <span slot="badge">
            <v-icon small style="font-size: 16px; padding: 0px 0px 1.5pt 0.4pt"
              >mdi-close-thick
            </v-icon></span
          >
        </v-badge>
        <v-avatar
          size="80"
          :color="avatarImage == '' ? 'grey lighten-4' : 'rgb(0, 0, 0, 0.0)'"
          class="my-5"
        >
          <span v-if="avatarImage == ''" class="text-h4">
            {{ user.id | INITIALS }}
          </span>
          <img
            v-else
            :src="avatarImage"
            style="height: auto; background-color: transparent"
          />
        </v-avatar>
      </div>
      <hr />
      <!-- edit buttons -->
      <div
        class="my-3 d-flex justify-space-between"
        style="max-width: 250px; margin: 0 auto"
      >
        <v-btn
          fab
          outlined
          color="blue accent-1"
          :disabled="!isCamera"
          @click="loadCamera = true"
        >
          <v-icon> fa fa-camera </v-icon>
        </v-btn>

        <v-btn
          fab
          outlined
          color="blue accent-1"
          @click="$refs.fileInput.click()"
        >
          <input
            type="file"
            multiple
            @change="onFileSelected"
            ref="fileInput"
            style="display: none"
          />
          <v-icon>fa fa-photo</v-icon>
        </v-btn>

        <v-btn fab outlined color="blue accent-1" @click="setIdenticon()">
          <div
            id="identicon"
            v-html="userIdenticon"
            style="margin-right: 3px; width: 34px; height: 34px"
          ></div>
        </v-btn>
      </div>
      <hr />
      <!-- smileys -->
      <div class="my-3 mx-n5" style="text-align: center">
        <v-btn
          v-for="(smiley, s) in smileys"
          :key="s"
          fab
          small
          class="mx-5 my-3"
          :style="isUsed(smiley) ? 'opacity: 0.25;' : ''"
          :disabled="isUsed(smiley)"
          @click="setSmiley(smiley)"
        >
          <img width="70" :src="'./smileys/smiley_' + smiley + '.png'" />
        </v-btn>
      </div>
      <!-- screensaver -->
      <hr />
      <v-row class="align-center">
        <v-col cols="4">
          <v-checkbox
            v-model="screenSaver"
            dense
            hide-details
            label="Smiley ScreenSaver"
            class="mt-1 mb-2 ml-3"
          ></v-checkbox
        ></v-col>
        <v-col
          v-if="screenSaver == 1"
          id="screenSaverTime"
          class="d-flex align-center"
        >
          <span>nach</span>
          <v-text-field
            v-model="screenSaverTime"
            type="number"
            dense
            outlined
            hide-details
            min="30"
            step="30"
            class="mx-1"
            style="max-width: 80px; padding: 3px"
          ></v-text-field>
          <span>Sekunden</span>
          <span class="ml-1 grey--text">
            ({{ (screenSaverTime / 60).toString().replace('.', ',') }}
            Minuten)
          </span>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            v-model="animate"
            dense
            hide-details
            label="Animation"
            class="mt-1 mb-2 ml-3"
          ></v-checkbox
        ></v-col>
      </v-row>

      <hr />
      <div class="mt-3 d-flex justify-space-between">
        <v-btn text color="secondary" class="mr-3" @click="$emit('close')">
          Abbrechen
        </v-btn>
        <v-btn text color="success" @click="saveAvatar()"> Übernehmen </v-btn>
      </div>
    </div>
    <div v-else>
      <capture-photo
        :cameraFile="cameraFile"
        @setImage="setImage($event)"
        @close="loadCamera = false"
      ></capture-photo>
    </div>
  </div>
</template>

<script>
import { toSvg } from 'jdenticon'

import CapturePhoto from './CapturePhoto.vue'

import { mapGetters } from 'vuex'

export default {
  props: ['avatar'],
  data() {
    return {
      path: process.env.VUE_APP_HOME,
      avatarImage: '',
      smileys: [],
      imgCount: 60,
      isCamera: true,
      loadCamera: false,
      cameraFile: '',
      usedSmileys: [],
      screenSaver: 0,
      screenSaverTime: 30,
      animate: 1,
    }
  },
  created() {
    this.detectWebcam((hasWebcam) => (this.isCamera = hasWebcam))
    // init smileys
    for (let i = 1; i <= this.imgCount; i++) {
      this.smileys.push(('00' + i).slice(-2))
    }

    // load used smileys
    this.$axios.get('pisa/user/smileys').then((res) => {
      res.data.forEach((el) => {
        if (el.avatar.indexOf('smiley') != -1)
          this.usedSmileys.push(el.avatar.substr(-6, 2))
      })
    })

    this.avatarImage = this.user.avatar
    this.screenSaver = this.user.screenSaver
    this.screenSaverTime = this.user.screenSaverTime
    this.animate = this.user.animate
  },
  computed: {
    ...mapGetters(['user', 'FULLNAME']),
    userIdenticon: function () {
      return toSvg(this.FULLNAME(this.user.id), 34)
    },
  },
  methods: {
    isUsed(smiley) {
      return this.usedSmileys.includes(smiley) ? true : false
    },
    setIdenticon() {
      var svg = document.querySelector('#identicon svg')
      var xml = new XMLSerializer().serializeToString(svg)
      var svg64 = btoa(xml) //for utf8: btoa(unescape(encodeURIComponent(xml)))
      var b64start = 'data:image/svg+xml;base64,'
      var image64 = b64start + svg64
      this.avatarImage = image64
    },
    setImage(img) {
      this.loadCamera = false
      // delete old
      if (this.avatarImage)
        if (this.avatarImage.indexOf('smiley') != -1) {
          this.usedSmileys.splice(
            this.usedSmileys.indexOf(this.avatarImage.substr(-6, 2)),
            1
          )
        }

      this.avatarImage = img
    },
    setSmiley(s) {
      // delete old
      if (this.avatarImage)
        if (this.avatarImage.indexOf('smiley') != -1) {
          this.usedSmileys.splice(
            this.usedSmileys.indexOf(this.avatarImage.substr(-6, 2)),
            1
          )
        }

      this.avatarImage = '/smileys/smiley_' + s + '.png'
      // set new
      this.usedSmileys.push(s)
    },
    delAvatar() {
      if (this.avatarImage.indexOf('smiley') != -1) {
        this.usedSmileys.splice(
          this.usedSmileys.indexOf(this.avatarImage.substr(-6, 2)),
          1
        )
      }
      this.avatarImage = ''
    },
    onFileSelected(e) {
      this.cameraFile = e.target.files[0]
      this.loadCamera = true
    },
    detectWebcam(callback) {
      let md = navigator.mediaDevices
      if (!md || !md.enumerateDevices) return callback(false)
      md.enumerateDevices().then((devices) => {
        callback(devices.some((device) => 'videoinput' === device.kind))
      })
    },
    saveAvatar() {
      this.user.screenSaver = this.screenSaver
      this.user.screenSaverTime = this.screenSaverTime
      this.user.animate = this.animate
      this.$emit('saveAvatar', this.avatarImage)
    },
  },
  beforeDestroy() {},
  components: {
    CapturePhoto,
  },
}
</script>

<style scoped>
.v-btn img {
  transition: transform 0.3s;
}

.v-btn img:hover {
  transform: scale(1.3);
  z-index: 5;
}

#screenSaverTime >>> .v-input__slot {
  min-height: 32px;
}
</style>
